export const _login_user = (user) => {
  return {
    type: "LOGIN_SUCCESS",
    user,
  };
};

export const _final_login_user = () => {
  return {
    type: "FINAL_LOGIN_SUCCESS",
  };
};

export const _set_i_user = (user) => {
  return {
    type: "SET_I_SUCCESS",
    user,
  };
};

export const _set_user_info = (user) => {
  return {
    type: "SET_I_SUCCESS",
    user,
  };
};

export const _logout_user = () => {
  return {
    type: "LOGOUT_SUCCESS",
  };
};

export const _set_discount_fake = (data) => {
  return {
    type: "SET_DISCOUNT_CODE",
    data,
  };
};

export const _set_store = (
  country_id,
  country_name,
  channel,
) => {
  return {
    type: "STORE_SUCCESS",
    country_id,
    country_name,
    channel,
  };
};

export const _edit_user = (user) => {
  return {
    type: "USER_EDIT_SUCCESS",
    user,
  };
};

export const _init_state = () => {
  return {
    type: "INIT_STATE",
  };
};

export const _set_cart_data = (credit, cart_data) => {
  return {
    type: "SET_CART_DATA",
    credit,
    cart_data,
  };
};

export const _set_product_id = (product_id) => {
  return {
    type: "SET_PRODUCT_ID",
    product_id,
  };
};

export const set_user_token = (token) => {
  return {
    type: "SET_USER_TOKEN",
    token,
  };
};

export const set_checkout_id = (payload) => {
  return {
    type: "SET_CHECKOUT_ID",
    payload,
  };
};

export const set_transaction_id = (payload) => {
  return {
    type: "SET_TRANSACTION_ID",
    payload,
  };
};

export const set_credit = (payload) => {
  return {
    type: "SET_CREDIT",
    payload,
  };
};
export const set_payment_options = (payload) => {
  return {
    type: "SET_PAYMENT_OPTIONS",
    payload,
  };
};

export const set_currency = (payload) => ({
  type: "SET_CURRENCY",
  payload,
});

export const _login_phone_number = (user) => ({
  type: "LOGIN_PHONE_NUMBER",
  user,
});

export const _set_channel = (channel, currentChannel) => ({
  type: "SET_CHANNEL",
  channel,
  clearCart: currentChannel === undefined ? true : channel !== currentChannel,
});

export const set_cid = (status) => ({
  type: "SET_CID",
  payload: status,
});

export const set_cpid = (status) => ({
  type: "SET_CPID",
  payload: status,
});

export const _set_pending_channel = (channel) => ({
  type: "SET_PENDING_CHANNEL",
  channel,
});

export const _set_pending_cpid = (cpid) => ({
  type: "SET_PENDING_CPID",
  cpid,
});

export const _set_pending_cid = (cid) => ({
  type: "SET_PENDING_CID",
  cid,
});

export const _clear_all_pending = () => ({
  type: "CLEAR_ALL_PENDING",
});

export const _set_channel_claimed = (channel, cpid, cid, currentChannel) => ({
  type: "SET_CHANNEL_CLAIMED",
  channel,
  cpid,
  cid,
  clearCart: currentChannel === undefined ? true : channel !== currentChannel,
});

export const set_url_code = (status) => ({
  type: "SET_URL_CODE",
  payload: status,
});

export const set_open_new_notification = (status) => ({
  type: "SET_OPEN_NEW_NOTIFICATION",
  payload: status,
});

export const set_notification_popover = (status) => ({
  type: "SET_NOTIFICATION_POPOVER",
  payload: status,
});
